var _g, _g2, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_483_7490)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 71,
    fill: "url(#paint0_radial_483_7490)",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_483_7490)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 86,
    r: 46,
    fill: "url(#paint1_radial_483_7490)",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.837 61.6286L63.3582 61.6599C69.6586 62.2864 75.079 64.835 79.5003 69.2564C83.0022 72.7583 86.2661 77.074 89.3005 82.2004L90.2039 83.7626L90.7732 83.0823C91.7072 81.9908 92.5676 81.1109 93.3639 80.4372C93.9421 79.9479 94.6836 79.4009 95.595 78.7895L96.3105 78.3188L97.6462 77.4789L99.1635 76.5673C99.6028 76.3084 100.071 76.1013 100.558 75.9501C103.879 74.9195 107.397 76.6449 108.649 79.8297L108.812 80.2944L112.667 92.718C116.033 103.564 112.151 115.315 103.074 122.031L102.347 122.551L100.073 124.119C89.3293 131.528 75.273 131.935 64.1441 125.244L63.2483 124.686L62.4541 124.174C51.09 116.842 45.8048 103.027 49.2907 90.0326L49.542 89.148L56.3881 66.3278C57.2447 63.4723 59.8988 61.5681 62.837 61.6286ZM80.6545 103.283L77.4657 106.471C74.2292 109.708 74.2292 114.955 77.4657 118.192L80.6545 121.381L83.8433 118.192C87.0798 114.955 87.0798 109.708 83.8433 106.471L80.6545 103.283Z",
    fill: "#E24141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.837 61.6286L63.3582 61.6599C69.6586 62.2864 75.079 64.835 79.5003 69.2564C83.0022 72.7583 86.2661 77.074 89.3005 82.2004L90.2039 83.7626L90.7732 83.0823C91.7072 81.9908 92.5676 81.1109 93.3639 80.4372C93.9421 79.9479 94.6836 79.4009 95.595 78.7895L96.3105 78.3188L97.6462 77.4789L99.1635 76.5673C99.6028 76.3084 100.071 76.1013 100.558 75.9501C103.879 74.9195 107.397 76.6449 108.649 79.8297L108.812 80.2944L112.667 92.718C116.033 103.564 112.151 115.315 103.074 122.031L102.347 122.551L100.073 124.119C89.3293 131.528 75.273 131.935 64.1441 125.244L63.2483 124.686L62.4541 124.174C51.09 116.842 45.8048 103.027 49.2907 90.0326L49.542 89.148L56.3881 66.3278C57.2447 63.4723 59.8988 61.5681 62.837 61.6286ZM80.6545 103.283L77.4657 106.471C74.2292 109.708 74.2292 114.955 77.4657 118.192L80.6545 121.381L83.8433 118.192C87.0798 114.955 87.0798 109.708 83.8433 106.471L80.6545 103.283Z",
    fill: "url(#paint2_radial_483_7490)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.209 138.266C102.909 137.809 103.916 136.06 103.459 134.36C103.001 132.66 101.253 131.653 99.5525 132.11L81.2838 137.024L63.0164 132.11L62.6519 132.034C61.0732 131.8 59.5349 132.782 59.1102 134.36C58.6529 136.06 59.6602 137.809 61.3602 138.266L69.0119 140.323L61.3602 142.386C59.6602 142.843 58.6529 144.592 59.1102 146.292C59.5676 147.992 61.3165 148.999 63.0164 148.542L81.2838 143.626L99.5525 148.542L99.9171 148.618C101.496 148.852 103.034 147.87 103.459 146.292C103.916 144.592 102.909 142.843 101.209 142.386L93.5525 140.323L101.209 138.266Z",
    fill: "#853E16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.209 138.266C102.909 137.809 103.916 136.06 103.459 134.36C103.001 132.66 101.253 131.653 99.5525 132.11L81.2838 137.024L63.0164 132.11L62.6519 132.034C61.0732 131.8 59.5349 132.782 59.1102 134.36C58.6529 136.06 59.6602 137.809 61.3602 138.266L69.0119 140.323L61.3602 142.386C59.6602 142.843 58.6529 144.592 59.1102 146.292C59.5676 147.992 61.3165 148.999 63.0164 148.542L81.2838 143.626L99.5525 148.542L99.9171 148.618C101.496 148.852 103.034 147.87 103.459 146.292C103.916 144.592 102.909 142.843 101.209 142.386L93.5525 140.323L101.209 138.266Z",
    fill: "url(#paint3_radial_483_7490)",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4659 106.472L80.6547 103.283L83.8435 106.472C87.08 109.708 87.08 114.955 83.8435 118.192L80.6547 121.381L77.4659 118.192C74.2295 114.955 74.2295 109.708 77.4659 106.472Z",
    fill: "#EDC254"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_483_7490",
    x: 0,
    y: 0,
    width: 162,
    height: 162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_483_7490"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_483_7490",
    x: 31,
    y: 36,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_483_7490"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_483_7490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81 60.3871) rotate(76.6075) scale(86.5222 103.323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#FFA564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_483_7490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81 40) rotate(90) scale(58.0227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_483_7490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79 113) rotate(-90) scale(51 48.9702)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270042,
    stopColor: "#ADFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_483_7490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.2845 137) rotate(90) scale(9 24.0885)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainFire);
export default __webpack_public_path__ + "static/media/MainFire.80f2df3e7f80bf630c502d44603f3369.svg";
export { ForwardRef as ReactComponent };